import React from 'react';
import { Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import {
    ContactSection, BadgeListSection, SocialSection,
    AboutSection, ExperienceSection, EducationSection, ReferencesSection,
} from './PdfSections';

const styles = StyleSheet.create({
    page: { padding: 30, fontSize: 10, fontFamily: 'Helvetica' },
    name: { fontSize: 18, fontWeight: 'bold', marginBottom: 4 },
    title: { fontSize: 11, color: '#555555', marginBottom: 8 },
    divider: { borderBottom: '1pt solid #cccccc', marginVertical: 10 },
    topRow: { flexDirection: 'row', justifyContent: 'space-between' },
    topRowCol: { width: '48%' },
});

function Template2Pdf(props) {
    const {
        name, about, email, address, phone, title,
        technicalSkills, languages, softSkills,
        linkedinURL, twitterURL, githubURL, websiteURL,
        educationData, jobData, showSocial, referenceData,
    } = props;

    return (
        <Document>
            <Page size="A4" style={styles.page} wrap>
                <Text style={styles.name}>{name}</Text>
                <Text style={styles.title}>{title}</Text>
                <View style={styles.divider} />

                <View style={styles.topRow}>
                    <View style={styles.topRowCol}>
                        <AboutSection about={about} />
                    </View>
                    <View style={styles.topRowCol}>
                        <ContactSection email={email} phone={phone} address={address} />
                        <SocialSection linkedinURL={linkedinURL} twitterURL={twitterURL} githubURL={githubURL} websiteURL={websiteURL} showSocial={showSocial} />
                    </View>
                </View>

                <View style={styles.divider} />

                <BadgeListSection title="Professional Skills" items={technicalSkills} />
                <BadgeListSection title="Soft Skills" items={softSkills} />
                <BadgeListSection title="Languages Known" items={languages} />

                <ExperienceSection jobData={jobData} />
                <EducationSection educationData={educationData} />
                <ReferencesSection referenceData={referenceData} />
            </Page>
        </Document>
    );
}

export default Template2Pdf;